import React from 'react';
import {
  Box,
  Controller,
  ControllerWrapper,
  FieldWrapper,
  FormFieldsContainer,
  Label,
  RegularField,
  useFormContext
} from '@common-fe/common-fe';

import { ChangePasswordField, ChangePasswordForm } from '@/modules/user/components/ChangePasswordModal/changePassword.types';

interface Props {
  editMode?: boolean;
}

const EnterNewPasswordFields: React.FC<Props> = ({ editMode }) => {
  const { control, formState: { errors } } = useFormContext<ChangePasswordForm>();

  return (
    <Box round="container1Round" background="canvas" pad="l" border={{ size: 'small', color: 'border1' }}>
      <FormFieldsContainer>
        <FieldWrapper>
          <Label name={ChangePasswordField.existingPassword} isNarrow>
            Existing password
          </Label>
          <ControllerWrapper errorText={errors?.[ChangePasswordField.existingPassword]?.message}>
            <Controller
              name={ChangePasswordField.existingPassword}
              control={control}
              render={({ field }) => (
                <RegularField
                  name={ChangePasswordField.existingPassword}
                  value={field.value}
                  onChange={field.onChange}
                  editMode={editMode}
                  placeholder="Enter your existing password"
                  isError={!!errors?.[ChangePasswordField.existingPassword]?.message}
                  type="password"
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>

        <FieldWrapper>
          <Label name={ChangePasswordField.newPassword} isNarrow>
            New password
          </Label>
          <ControllerWrapper errorText={errors?.[ChangePasswordField.newPassword]?.message}>
            <Controller
              name={ChangePasswordField.newPassword}
              control={control}
              render={({ field }) => (
                <RegularField
                  name={ChangePasswordField.newPassword}
                  value={field.value}
                  onChange={field.onChange}
                  editMode={editMode}
                  placeholder="Choose a new password"
                  isError={!!errors?.[ChangePasswordField.newPassword]?.message}
                  passwordHelper
                  passwordHelperLeftPosition
                  type="password"
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>

        <FieldWrapper>
          <Label name={ChangePasswordField.confirmNewPassword} isNarrow>
            Confirm new password
          </Label>
          <ControllerWrapper errorText={errors?.[ChangePasswordField.confirmNewPassword]?.message}>
            <Controller
              name={ChangePasswordField.confirmNewPassword}
              control={control}
              render={({ field }) => (
                <RegularField
                  name={ChangePasswordField.confirmNewPassword}
                  value={field.value}
                  onChange={field.onChange}
                  editMode={editMode}
                  placeholder="Confirm a new password"
                  isError={!!errors?.[ChangePasswordField.confirmNewPassword]?.message}
                  type="password"
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>
      </FormFieldsContainer>
    </Box>
  );
};

export default EnterNewPasswordFields;
